export const SOCIAL_NETWORKS = [
  ["instagram", "Instagram", "https://www.instagram.com/tu_negocio/"],
  ["facebook", "Facebook", "https://www.facebook.com/tu_negocio"],
  ["tiktok", "TikTok", "https://www.tiktok.com/@tu_negocio"],
  ["youtube", "YouTube", "https://www.youtube.com/@tu_negocio"],
  ["x", "X", "https://x.com/tu_negocio"],
  ["telegram", "Telegram", "https://t.me/tu_canal"],
  ["whatsapp", "WhatsApp", "https://wa.me/573001234567"]
];
export const safeSocialUrl = value => {
  try { const url = new URL(value); return url.protocol === "https:" && !url.username && !url.password ? url.href : ""; } catch { return ""; }
};
